module.exports = __webpack_public_path__ + "static/media/title.b3c9348b.png";